export class ProjectBoxWallGroupWall {
    public position: number | null = null;
    public name: string | null = null;
    public forcedState: string | null = null;
}